(function () {
  function toInt(val, fallback) {
    var n = parseInt(val, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function updateQtyWithin(container, variantId) {
    if (!container || !variantId) return;

    // Your hidden per-variant divs: <div id="v{{id}}" data-min-qty="..." data-inc-qty="...">
    var metaEl = container.querySelector("#v" + variantId) || document.getElementById("v" + variantId);
    if (!metaEl) return;

    var minQty = toInt(metaEl.getAttribute("data-min-qty"), 1);
    var incQty = toInt(metaEl.getAttribute("data-inc-qty"), 1);

    // Find the quantity input in THIS product container
    var qtyInput = container.querySelector('[data-quantity-selector] [data-quantity-input]');
    if (!qtyInput) return;

    // Update native input attributes
    qtyInput.min = String(minQty);
    qtyInput.step = String(incQty);
    qtyInput.setAttribute("data-increment-value", String(incQty));
    qtyInput.dataset.incrementValue = String(incQty);

    // Normalize value if needed
    var current = qtyInput.valueAsNumber;
    if (!Number.isFinite(current) || current < minQty) {
      qtyInput.value = String(minQty);
    }

    // Update Empire v12 QuantitySelector instance used by +/- buttons
    var qtyField = qtyInput.closest('[data-quantity-selector]');
    if (qtyField && qtyField.__quantitySelector) {
      qtyField.__quantitySelector.incrementValue = incQty;
      if (typeof qtyField.__quantitySelector._updateMinusButton === "function") {
        qtyField.__quantitySelector._updateMinusButton();
      }
    }

    qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  var bound = new WeakSet();

  function bindIn(root) {
    root = root || document;

    // Empire v12 uses <variant-selection> custom element
    var variantSelections = root.querySelectorAll("variant-selection");
    if (!variantSelections.length) return;

    variantSelections.forEach(function (vs) {
      if (bound.has(vs)) return;
      bound.add(vs);

      // pick a reasonable “container” to scope searches (section / product form area)
      var container =
        vs.closest("[data-section-id]") ||
        vs.closest("[data-product-form]") ||
        vs.closest("section") ||
        document;

      // Initial run
      var initialId = toInt(vs.getAttribute("variant"), null);
      if (initialId) updateQtyWithin(container, initialId);

      // On variant change (does NOT bubble, so must listen on vs itself)
      vs.addEventListener("variant-change", function (e) {
        var v = e && e.detail && e.detail.variant;
        if (v && v.id) updateQtyWithin(container, v.id);
      });
    });
  }

  // Normal page load
  document.addEventListener("DOMContentLoaded", function () {
    bindIn(document);
  });

  // Theme editor / dynamic section loads (common reason it "only works after refresh")
  document.addEventListener("shopify:section:load", function (event) {
    bindIn(event.target);
  });

  // Safety net: if the product section is injected after DOMContentLoaded (quickshop, etc.)
  var mo = new MutationObserver(function () {
    bindIn(document);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
